import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useBidderAdvertiserTableOfContents = () => {
	const [isTableOfContents, setIsTableOfContents] = useState<boolean>(false);
	const location = useLocation();

	useEffect(() => {
		return () => setIsTableOfContents(false);
	}, [location]);

	return {
		isTableOfContents,
		tableOfContents: [{ id: 'basicInfo', element: 'Basic Info' }],
		setIsTableOfContents,
	};
};
